import { IApplicationState } from '../../../../types/types';
import { getAuthUser } from './getAuthUser';

export const getAuthUserAllowChecklistItemCount = (
    state: IApplicationState
): number => {
    const user = getAuthUser(state);
    return user.allowChecklistItemCount;
}
